module.exports = __webpack_public_path__ + "img/u_mailbox.32001fba.svg";